(() => {
  window.swinger = {
    ...window.swinger,
    retargeting: {
      adcell: {
        conversion: (params) => {
          if (!window.swinger.consent.isAllowed('marketing')) {
            return;
          }

          if (
            !window.swinger
            || !window.swinger.config
            || !window.swinger.config.adcellPid
          ) {
            return;
          }

          params.pid = window.swinger.config.adcellPid;

          const bid = (() => {
            const affiliate = window.swinger.user.getAffiliateInfo();

            return affiliate.class === 'Adcell' ? affiliate.bid : undefined;
          })();

          if (!bid) {
            return;
          }

          params.bid = bid;
          params.eventId = '10142';

          const searchParams = new URLSearchParams(params);
          window.swinger.resourceLoader.script(`https://t.adcell.com/t/track.js?${searchParams.toString()}`);
        },
        container: (params) => {
          if (!window.swinger.consent.isAllowed('marketing')) {
            return;
          }

          if (
            !window.swinger
            || !window.swinger.config
            || !window.swinger.config.adcellPid
          ) {
            return;
          }

          if (!params.method) {
            return;
          }

          const affiliate = window.swinger.user.getAffiliateInfo();

          if (affiliate.class !== 'Adcell') {
            return;
          }

          params.pid = window.swinger.config.adcellPid;

          const searchParams = new URLSearchParams(params);
          window.swinger.resourceLoader.script(`https://www.adcell.de/js/inlineretarget.js?${searchParams.toString()}`);
        },
      },
    },
  };

  if (window.swinger.config.adCellQueryParams) {
    const { adCellQueryParams } = window.swinger.config;
    window.swinger.retargeting.adcell.container(adCellQueryParams);
  }

  // Remove potential tracking parameters from URL
  if (!window.swinger.config.retargetingParams) {
    return;
  }

  window.setTimeout(() => {
    const url = new URL(window.location);
    const params = url.searchParams;

    if (!params) {
      return;
    }

    window.swinger.config.retargetingParams.forEach((name) => {
      params.delete(name);
    });

    window.history.replaceState(null, document.title, url.toString());
  });
})();
